import type { SVGProps } from "react";
import { memo } from "react";

import { cn } from "@btnet/utilities-core";

import "./Icon.less";
import type { IIconProps } from "./Icon.types";

const SvgIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M16 2c1.777 0 3.374.773 4.472 2H25a2 2 0 0 1 1.994 1.85L27 6v21a2 2 0 0 1-1.85 1.994L25 29H7a2 2 0 0 1-1.995-1.85L5 27V6a2 2 0 0 1 1.85-1.995L7 4h4.528A5.99 5.99 0 0 1 16 2m5.659 4c.19.536.305 1.108.334 1.701L22 8v1a1 1 0 0 1-.883.993L21 10H11a1 1 0 0 1-.993-.883L10 9V8c0-.701.12-1.374.341-2H7v21h18V6zm-9.654 1.8A4 4 0 0 1 16 4l.2.005.203.015A4 4 0 0 1 20 8h-8z"
      clipRule="evenodd"
    />
  </svg>
);
const SvgIconClipboard = ({
  testid,
  size = "md",
  className,
  ariaLabel,
  innerRef,
  ...props
}: IIconProps) => {
  const ariaVisibilityProp = ariaLabel
    ? {
        "aria-label": ariaLabel,
      }
    : {
        "aria-hidden": true,
      };
  return (
    <div
      data-testid={testid}
      className={cn("icon bds-icon", className, {
        ["bds-icon-" + size]: size,
        ["icon-" + size]: size,
      })}
      ref={innerRef}
      {...props}
    >
      <SvgIcon role="img" fill="none" {...ariaVisibilityProp} />
    </div>
  );
};
const Memo = memo(SvgIconClipboard);
export default Memo;
